import React, { useState, useRef, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  DateFormat,
  RouteLinks
} from '../../config/react'

const EditAppointment = () => {
  const urlParams = useParams()
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [AppointmentUsers, setAppointmentUsers] = useState([])
  const history = useHistory()
  const validator = useRef(new SimpleReactValidator())
  useEffect(() => {
    document.title = Title.AddService
    if (urlParams.id !== undefined) {
      document.title = Title.EditService
      GetAppointmentUsers()
      GetAppointmentDetail()
    }
  }, [urlParams.id])
  const [Inputs, setInputs] = useState({
    id: 0,
    remarks: '',
    status: '',
    user_id: ''
  })

  const handleInputChanges = (e) => {
    const field = e.target.name
    const fieldval = e.target.value
    Inputs[field] = fieldval

    setForceUpdate(!isForceUpdate)
  }

  const SubmitForm = (e) => {
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }
    const param = {
      id: Inputs.id,
      remarks: Inputs.remarks,
      status: Inputs.status ?? 'Pending',
      user_id: Inputs.user_id
    }
    // console.log(param);
    HttpService.postApi(API.setAppointment, param).then((response) => {
      if (response.data.message) {
        toast.warning(response.data.message)
        setForceUpdate(!isForceUpdate)
        return
      }
      if (urlParams.id !== undefined) toast.success(Messages.RecordAdded)
      else toast.success(Messages.RecordUpdated)
      setForceUpdate(!isForceUpdate)
      history.push('/Appointments')
    })
  }

  const GetAppointmentDetail = () => {
    const param = {
      page: 1,
      search: '',
      page_size: 10,
      id: urlParams.id
    }
    HttpService.postApi(API.GetAppointment, param, false).then((response) => {
      if (response.data.result) {
        const data = response.data.result[0]
        const service = data.filter((x) => x.id === Number(urlParams.id))[0]
        // console.log(service);
        setInputs(service)
        setForceUpdate(!isForceUpdate)
      }
    })
  }
  const GetAppointmentUsers = () => {
    HttpService.getApi(API.GetAppointmentUsers).then((response) => {
      if (response.data.result) {
        const data = response.data.result[0]
        setAppointmentUsers(data)
      }
    })
  }

  const GoBack = () => {
    if (history.length > 2) {
      history.goBack()
    } else {
      history.push(RouteLinks.Appointment)
    }
  }
  return (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0"> {Title.EditAppointment} </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={GoBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label className="col-4">
                        <b>Name</b>
                      </label>
                      <label className="col-8">{Inputs.name}</label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label className="col-4">
                        <b>Email</b>
                      </label>
                      <label className="col-8">{Inputs.email}</label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label className="col-4">
                        <b>Phone</b>
                      </label>
                      <label className="col-8">{Inputs.contact_number}</label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label className="col-4">
                        <b>Booking Date</b>
                      </label>
                      <label className="col-8">
                        <DateFormat value={Inputs.booking_date}></DateFormat>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label className="col-4">
                        <b>Service Type</b>
                      </label>
                      <label className="col-8">{Inputs.service_type}</label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group row">
                      <label className="col-4">
                        <b>Place Date</b>
                      </label>
                      <label className="col-8">
                        <DateFormat value={Inputs.created_at}></DateFormat>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="fw-bold mb-2">Description</label>

                      <div
                        style={{
                          background: '#f8f9fa',
                          padding: '12px 15px',
                          borderRadius: '8px',
                          border: '1px solid #e0e0e0',
                          fontSize: '14px',
                          lineHeight: '1.6',
                          whiteSpace: 'pre-line'
                        }}
                      >
                        {Inputs.item_description || 'No description provided'}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Remarks</label>
                      <textarea
                        rows={5}
                        type="textarea"
                        className="form-control"
                        name="remarks"
                        onChange={handleInputChanges}
                        value={Inputs.remarks}
                        placeholder="Remarks"
                      />
                      {validator.current.message('remarks', Inputs.remarks, 'required|max:255', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Status</label>
                      <select
                        className="form-control"
                        name="status"
                        onChange={handleInputChanges}
                        value={Inputs.status}
                      >
                        <option value="Select">Select</option>
                        <option value="In progress">In progress</option>
                        <option value="Successful">Successful</option>
                        <option value="Unsuccessful">Unsuccessful</option>
                      </select>
                      {/* {validator.current.message('Status', Inputs.status, 'required', { className: 'error' })} */}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Assign To</label>
                      <select
                        className="form-control"
                        name="user_id"
                        onChange={handleInputChanges}
                        value={Inputs.user_id}
                      >
                        {/* <option value="Select">Select</option> */}
                        {AppointmentUsers.map((item, index) => (
                          <option
                            value={item.id}
                            key={index}
                          >
                            {item.name}
                          </option>
                        ))}
                      </select>
                      {/* {validator.current.message('Status', Inputs.status, 'required', { className: 'error' })} */}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <button
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-primary mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/Appointments"
                      className="btn btn-light"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default EditAppointment
